import React from 'react';
import Tooltip from './Tooltip';

const Container = ({
	title,
	tooltip,
	link,
	export_link,
	cta_link,
	cta_label,
	children,
}) => {
	return (
		<div className="bg-white rounded-lg border border-[#EEF0FF] overflow-hidden">
			<div className="p-4 border-b border-b-[#EEF0FF] flex items-center justify-between">
				<div className="flex items-center gap-3">
					<h4 className="text-xl font-medium text-ec-title">{title}</h4>

					{tooltip && <Tooltip text={tooltip} />}
				</div>

				{export_link && (
					<button className="flex items-center gap-1.5 border border-[#7A7A99] text-[#7A7A99] rounded-[4px] px-2.5 py-1.5">
						<svg
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12.6657 0H8.66574C8.48893 0 8.31936 0.0702379 8.19434 0.195262C8.06932 0.320286 7.99908 0.489856 7.99908 0.666667C7.99908 0.843478 8.06932 1.01305 8.19434 1.13807C8.31936 1.2631 8.48893 1.33333 8.66574 1.33333H11.0564L5.52774 6.862C5.46407 6.9235 5.41328 6.99706 5.37834 7.0784C5.3434 7.15973 5.32501 7.24721 5.32424 7.33573C5.32347 7.42425 5.34034 7.51204 5.37386 7.59397C5.40738 7.6759 5.45689 7.75033 5.51948 7.81293C5.58208 7.87552 5.65651 7.92503 5.73844 7.95855C5.82037 7.99207 5.90816 8.00894 5.99668 8.00817C6.0852 8.0074 6.17268 7.98901 6.25401 7.95407C6.33535 7.91913 6.40891 7.86834 6.47041 7.80467L11.9991 2.276V4.66667C11.9991 4.84348 12.0693 5.01305 12.1943 5.13807C12.3194 5.2631 12.4889 5.33333 12.6657 5.33333C12.8426 5.33333 13.0121 5.2631 13.1371 5.13807C13.2622 5.01305 13.3324 4.84348 13.3324 4.66667V0.666667C13.3324 0.489856 13.2622 0.320286 13.1371 0.195262C13.0121 0.0702379 12.8426 0 12.6657 0Z"
								fill="#7F7F98"
							/>
							<path
								d="M11.3333 5.72598C11.1565 5.72598 10.987 5.79622 10.8619 5.92125C10.7369 6.04627 10.6667 6.21584 10.6667 6.39265V11.168C10.6665 11.3888 10.5787 11.6005 10.4226 11.7566C10.2665 11.9127 10.0548 12.0005 9.834 12.0007H2.166C1.94522 12.0005 1.73353 11.9127 1.57741 11.7566C1.42129 11.6005 1.33351 11.3888 1.33333 11.168V3.49998C1.33351 3.2792 1.42129 3.06751 1.57741 2.9114C1.73353 2.75528 1.94522 2.66749 2.166 2.66732H6.314C6.49081 2.66732 6.66038 2.59708 6.7854 2.47206C6.91043 2.34703 6.98067 2.17746 6.98067 2.00065C6.98067 1.82384 6.91043 1.65427 6.7854 1.52925C6.66038 1.40422 6.49081 1.33398 6.314 1.33398H2.166C1.59176 1.33469 1.04124 1.56312 0.635186 1.96917C0.229135 2.37522 0.000705675 2.92574 0 3.49998V11.1667C0.000352762 11.7411 0.228626 12.292 0.634716 12.6983C1.0408 13.1047 1.59153 13.3333 2.166 13.334H9.83267C10.4071 13.3336 10.958 13.1054 11.3643 12.6993C11.7707 12.2932 11.9993 11.7425 12 11.168V6.39265C12 6.21584 11.9298 6.04627 11.8047 5.92125C11.6797 5.79622 11.5101 5.72598 11.3333 5.72598Z"
								fill="#7F7F98"
							/>
						</svg>
						Export
					</button>
				)}

				{cta_link && cta_label && (
					<a
						href={cta_link}
						className="flex items-center gap-1.5 bg-[#FF4B33] hover:bg-[#9A1200] duration-300 text-white rounded-[6px] px-2.5 py-1.5"
					>
						<svg
							width="16"
							height="10"
							viewBox="0 0 16 10"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M15.7965 0.195191C15.9215 0.32021 15.9917 0.489748 15.9917 0.666524C15.9917 0.8433 15.9215 1.01284 15.7965 1.13786L9.46314 7.47119C9.33812 7.59617 9.16858 7.66638 8.99181 7.66638C8.81503 7.66638 8.64549 7.59617 8.52048 7.47119L5.65847 4.60919L1.12981 9.13786C1.00407 9.2593 0.835672 9.32649 0.660874 9.32497C0.486076 9.32346 0.318868 9.25334 0.195262 9.12974C0.0716568 9.00613 0.00154415 8.83892 2.52017e-05 8.66413C-0.00149374 8.48933 0.0657025 8.32093 0.187141 8.19519L5.18714 3.19519C5.31216 3.07021 5.4817 3 5.65847 3C5.83525 3 6.00479 3.07021 6.12981 3.19519L8.99181 6.05719L14.8538 0.195191C14.9788 0.0702104 15.1484 0 15.3251 0C15.5019 0 15.6715 0.0702104 15.7965 0.195191Z"
								fill="white"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M10.6602 0.666667C10.6602 0.489856 10.7304 0.320287 10.8554 0.195262C10.9804 0.070238 11.15 0 11.3268 0H15.3268C15.5036 0 15.6732 0.070238 15.7982 0.195262C15.9233 0.320287 15.9935 0.489856 15.9935 0.666667V4.66667C15.9935 4.84348 15.9233 5.01305 15.7982 5.13807C15.6732 5.2631 15.5036 5.33333 15.3268 5.33333C15.15 5.33333 14.9804 5.2631 14.8554 5.13807C14.7304 5.01305 14.6602 4.84348 14.6602 4.66667V1.33333H11.3268C11.15 1.33333 10.9804 1.2631 10.8554 1.13807C10.7304 1.01305 10.6602 0.843478 10.6602 0.666667Z"
								fill="white"
							/>
						</svg>
						{cta_label}
					</a>
				)}

				{/* {link && (
					<a
						href={link}
						className="flex items-center gap-1.5 border border-[#7A7A99] text-[#7A7A99] rounded-[4px] px-2.5 py-1"
					>
						View All
					</a>
				)} */}

                {link && (
                    <a
                        href={link}
                        className="group w-7 h-7 flex items-center justify-center rounded-full border-[0.5px] border-[#dbdbdb] bg-[#F2F2F8] hover:bg-ec-primary duration-300"
                    >
                        <svg
                            width="10"
                            height="10"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0.856454 10C1.08372 9.9998 1.30161 9.90936 1.46221 9.74857L8.28559 2.92571V6.85714C8.28559 7.08447 8.3759 7.30249 8.53666 7.46323C8.69741 7.62398 8.91545 7.71429 9.14279 7.71429C9.37014 7.71429 9.58817 7.62398 9.74893 7.46323C9.90969 7.30249 10 7.08447 10 6.85714V0.857143C9.99961 0.80439 9.99435 0.751786 9.98429 0.7V0.691429C9.97371 0.64261 9.95889 0.594809 9.94 0.548571V0.537143C9.92023 0.487352 9.89583 0.439523 9.86713 0.394286V0.384286C9.80116 0.287582 9.71607 0.205417 9.61712 0.142857H9.60854C9.5633 0.11416 9.51547 0.089768 9.46568 0.07H9.45425C9.408 0.0511038 9.3602 0.0362855 9.31138 0.0257143H9.29995C9.24848 0.0122855 9.19586 0.00367687 9.14279 0H3.14234C2.915 4.79059e-09 2.69696 0.0903059 2.5362 0.251051C2.37545 0.411797 2.28513 0.629814 2.28513 0.857143C2.28513 1.08447 2.37545 1.30249 2.5362 1.46323C2.69696 1.62398 2.915 1.71429 3.14234 1.71429H7.07407L0.250694 8.53714C0.130963 8.65701 0.0494434 8.80967 0.0164302 8.97584C-0.016583 9.14201 0.000391266 9.31424 0.0652092 9.47077C0.130027 9.6273 0.239781 9.76111 0.38061 9.85531C0.521438 9.9495 0.687024 9.99985 0.856454 10Z"
                                className="fill-[#7A7A99] group-hover:fill-white duration-300"
                            />
                        </svg>
                    </a>
                )}
			</div>

			<div className="p-4 min-h-[385px]">{children}</div>
		</div>
	);
};
export default Container;
